import Backbone from 'backbone';
import NavItem from '@/models/nav/nav';

    export default Backbone.Collection.extend({ 
        initialize: function() {
            this.on('change:selected', this.reset_selections, this);
        },
        model: NavItem,
        reset_selections: function(changed_model, selected) {
            // Don't do anything on deselect
            if (!selected) return;
            // If a selection was made, deselect everything else
            this.each(function(model){
                if (model === changed_model) return;
                model.set('selected', false);
            });

        }
    });

